module.exports = __webpack_public_path__ + "img/energy.d9e6f96.svg";